import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect'

import { Button } from 'components'
import PlanetAnimation from './PlanetAnimation'

import classes from './ErrorScreen.module.css'

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ErrorScreen = props => {
    const {
        error
    } = props;
    let content = <div>Something went wrong</div>
    let img = <PlanetAnimation/>
    let title = 'Oh snap'
    let subtitle = "Something went wrong, sorry about that"
    switch (error) {
        case 'page-not-found':
            title = 'Page not found'
            subtitle = 'The page that you were looking for is not available'
            break;
        case 'no-access':
            title = 'No access'
            subtitle = "You don't have access to view this page"
            break;
        default:
            break;
    }

    const buttonStyle = {
        backgroundColor: '#957fef',
        fontSize: '1rem',
        padding: '0.5rem',
        // fontWeight: 'bold',
        margin: '0 0 2rem 0',
        width: '5rem'
    }

    return (
        <Container>
            <div className={classes.Container}>
                <div className={classes.Title}>{title}</div>
                <div className={classes.Subtitle}>{subtitle}</div>
                <Button text='Back' styles={buttonStyle} onSelect={() => window.history.back()}/>
                {!isMobile && <div className={classes.Banner}>{img}</div>}
            </div>
        </Container>
        
    )
}

export default ErrorScreen;